const wowApp = require('angular').module('wowApp.shop');

//Services
wowApp.service('FiltersService', ['$rootScope', '$state', '$stateParams', '$timeout', 'Restangular', 'LocalStorageService', require('./filters-service')]);

//Directive
wowApp.directive('bwsFilters', ['AtmService', 'FiltersService', '$stateParams', require('./filters-directive')]);
wowApp.directive('filterBrand', ['FiltersService', require('./advance-filter/filter-brand-directive')]);
wowApp.directive('filterMobBrand', ['FiltersService', require('./advance-filter/filter-brand-mob-directive')]);
wowApp.directive('brandScrollTop', [require('./advance-filter/filter-brand-scroll-top')]);
wowApp.directive('filterPrice', ['FiltersService', require('./advance-filter/filter-price-directive')]);
wowApp.directive('filterList', ['AtmService', 'FiltersService', require('./advance-filter/filter-list-directive')]);
wowApp.directive('wowFilterHeaderMobile', ['FiltersService', require('./filter-header-mobile-directive')]);
wowApp.directive('wowFiltersMobile', ['$timeout', 'FiltersService', require('./filters-mobile-directive')]);
wowApp.directive('wowQuickFilters', ['FiltersService', 'SettingsService', '$state', '$rootScope', '$timeout', 'BreakpointsService', require('./quick-filters-directive')]);

wowApp.run(($templateCache) => {
  $templateCache.put('filter-brand-accordian-heading.html', require('./advance-filter/filter-brand-accordian-heading.html'));
});
wowApp.run(($rootScope) => {
  $rootScope.$on('$locationChangeStart', function () {
    const _sift = (window._sift = window._sift || []);
    _sift.push(['_trackPageview']);
  });
});



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/index.js
 **/